import React from 'react';
import { Rater } from '../../../types/rater';
import { Flex } from '@mantine/core';

interface BodyProps {
  data: Rater[];
  type?: 'rater' | 'expectation';
}

const Body: React.FC<BodyProps> = ({ data, type }) => {
  if (data.length === 0) {
    return (
      <Flex
        flex={1}
        justify="center"
        p={16}
        style={{ borderRight: '1px solid rgb(204, 204, 204)' }}
      >
        <p className="text-center m-0">No Data</p>
      </Flex>
    );
  }

  return (
    <>
      {data.map((item, index) => {
        return (
          <div
            className={`row-table-method ${
              index !== data.length - 1 && 'b-border'
            }`}
            key={index}
          >
            <div className="row-table-method__numbering">
              <p className='m-0'>{index + 1}</p>
            </div>
            <div className="row-table-method__column__description">
              <p className='m-0'>{item?.title}</p>
            </div>
            <div className="row-table-method__column">
              <p className='m-0'>{item?.scoreExpectation}</p>
            </div>
            {type === 'rater' && (
              <div className="row-table-method__column">
                <p className='m-0'>{item?.scoreRater}</p>
              </div>
            )}
          </div>
        );
      })}
    </>
  );
};

export default Body;
